import request from '../../../../api/request';
import { SelectOptionType } from '@octano/global-ui';

export interface OptionsFormDataResponse {
  campuses: SelectOptionType[];
  schools: SelectOptionType[];
}

const PERSONAL_BACKGROUND = {
  FORM_DATA: () => `maintainers-portal/teacher-management/teacher-file/form`,
};

export async function getFormData() {
  return request<OptionsFormDataResponse>(PERSONAL_BACKGROUND.FORM_DATA(), {
    method: 'GET',
  });
}
